module.exports = __webpack_public_path__ + "static/media/bunny-logo.6c8e0b93.svg";